import { AppNavigation } from "../../../documents"

export interface UpdateNavigationRequest {
  navigation: AppNavigation
}
